import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../common.service';
import { Cluster } from '../../../types/tenant.types';
import { AwaitingClusterFeeRun, UnpaidClusterFeeType } from '../model/cluster-fee-run.models';

@Injectable({ providedIn: 'root' })
export class ClusterFeeRunService {
  private readonly api = inject(ApiService);

  getClustersList(): Observable<Cluster[]> {
    return this.api.get('disbursements/get-user-clusters');
  }

  getUpaidClusterFeeRun(payload: {
    statusIds: number[];
    clusterId: number | null;
  }): Observable<UnpaidClusterFeeType[]> {
    return this.api.post(`disbursements/get-cluster-fee-run-details`, payload);
  }

  getClusterFeeRunAwaitingList(clusterId: number): Observable<AwaitingClusterFeeRun[]> {
    let params: Record<string, string | number> | undefined;

    if (clusterId !== null) {
      params = { clusterId };
    }

    return this.api.get('disbursements/get-cluster-fee-run-awaitingApproval', params);
  }

  postCloseClusterFeeRun(
    payload: { tenantId: number; fromDate: string; toDate: string }[],
  ): Observable<void> {
    return this.api.post(`disbursementbatch/close-fee-run-for-cluster`, payload);
  }

  getClusterFeeRunApproved(): Observable<AwaitingClusterFeeRun[]> {
    return this.api.get('disbursements/get-cluster-fee-run-approved');
  }

  approveClusterFeeRun(payload: { batchIds: number[] }): Observable<void> {
    return this.api.post(`disbursements/approve-fee-run-for-cluster`, payload);
  }

  rejectClusterFeeRun(payload: { batchIds: number[] }): Observable<void> {
    return this.api.post(`disbursements/reject-fee-run-for-cluster`, payload);
  }
}
